<template>
  <v-app>
    <router-view />
    <success-snackbar
      v-if="snackbar"
      :open="open"
      :title="snackbarTitle"
      :message="snackbarMessage"
      :type="snackbar.type"
    />
    <revolut-pay-checkout />
    <payment-provider-choice />
    <cookie-consent />
  </v-app>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { workflowLabel } from '@/admin-i18n/workflows-all-display'
import { organizationText } from '@/components/organizations/organization-all-display'
import SuccessSnackbar from '@/components/shared/snackbars/success-snackbar.vue'
import RevolutPayCheckout from '@/components/accreditations/RevolutPayCheckout.vue'
import PaymentProviderChoice from '@/components/accreditations/PaymentProviderChoice.vue'
import CookieConsent from '@/components/shared/cookie-consent.vue'
import {EventBus} from '@/plugins/event-bus.js'

export default {
  name: 'app',
  mixins: [AdminContext],
  components: { SuccessSnackbar, RevolutPayCheckout, PaymentProviderChoice, CookieConsent },
  data: () => ({
    snackbar: null,
  }),
  computed:{
    snackbarTitle() {
      if (this.snackbar && this.snackbar.adminEventActionError) return this.adminText('events.actionError', 'Unable to complete action')

      if (this.snackbar && this.snackbar.adminOrganizationNotification) return organizationText.call(this, this.snackbar.title)

      if (this.snackbar && this.snackbar.adminWorkflowNotification) return workflowLabel.call(this, this.snackbar.title)

      return this.snackbar && this.snackbar.title
    },
    snackbarMessage() {
      if (this.snackbar && this.snackbar.adminEventActionError) return this.adminText('events.tryAgain', 'Something went wrong. Please try again.')

      if (this.snackbar && this.snackbar.adminOrganizationNotification) return organizationText.call(this, this.snackbar.message)

      if (this.snackbar && this.snackbar.adminWorkflowNotification) return workflowLabel.call(this, this.snackbar.message)

      return this.snackbar && this.snackbar.message
    },
    open() {
      return !!this.snackbar
    },
  },
  updated() {
    document.title = 'CoreEvent'
  },
  mounted() {
    EventBus.$on('toggle-snackbar', this.handleOpenSnackbar)
  },
  destroyed() {
    EventBus.$off('toggle-snackbar', this.handleOpenSnackbar)
  },
  methods: {
    organizationText,
    workflowLabel,
    handleOpenSnackbar(data = null) {
      this.snackbar = data
    },
  },
}
</script>

<style>
@font-face {
  font-family: MuseoSans;
  src: url(https://accreditationmanager.s3.eu-central-1.amazonaws.com/fonts/MuseoSans-300.ttf);
}
@font-face {
  font-family: Rubik;
  src: url('../public/assets/fonts/Rubik-VariableFont_wght.ttf');
}
@font-face {
  font-family: MuseoSans;
  src: url(https://accreditationmanager.s3.eu-central-1.amazonaws.com/fonts/MuseoSans-300Italic.ttf);
  font-style: italic;
}
@font-face {
  font-family: GothamRounded;
  src: url(https://accreditationmanager.s3.eu-central-1.amazonaws.com/fonts/GothamRoundedMedium_21022.ttf);
}
@font-face {
  font-family: GothamRounded;
  src: url(https://accreditationmanager.s3.eu-central-1.amazonaws.com/fonts/GothamRoundedBold_21016.ttf);
  font-style: bold;
}

@font-face {
  font-family: 'NouvelR-Regular';
  src: url(https://accreditationmanager.s3.eu-central-1.amazonaws.com/fonts/NouvelR-Regular.ttf);
}

root,
html,
body {
  font-size: 16px !important;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 425px) {
  root,
  html,
  body {
    font-size: 14px !important;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

a {
  text-decoration: none;
}
.custom-error-message {
  padding: 0 12px;
  margin-top: 8px;
  font-size: 12px;
}
.custom-error-color {
  color: #db384c !important;
}
.custom-error-border {
  border: 2px #db384c solid;
}
.custom-error-bottom-border {
  border-bottom: 2px #db384c solid;
}

.title-description {
  display: none;
  /* padding-left: 12px; */
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  color: #979797;
}
.submit-info {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  padding-top: 16px;
  color: #979797;
}

.mb-58 {
  margin-bottom: 58px !important;
}

.mb-22 {
  margin-bottom: 22px !important;
}

.mb-16 {
  margin-bottom: 16px !important;
}

.pb-16 {
  margin-bottom: 16px !important;
}
.pt-16 {
  padding-top: 16px !important;
}

.pt-20 {
  margin-top: 20px !important;
}

.pt-8 {
  margin-top: 8px !important;
}

.mb-8 {
  margin-bottom: 8px !important;
}

.mb-12 {
  margin-bottom: 12px !important;
}
.mb-50 {
  margin-bottom: 50px !important;
}

.mt-8 {
  margin-top: 8px !important;
}
.mt-12 {
  margin-top: 12px !important;
}
.mt-220 {
  margin-top: 220px;
}
.ml-12 {
  margin-left: 12px !important;
}

.ml-20 {
  margin-left: 20px !important;
}

.ml-32 {
  margin-left: 32px !important;
}

.pl-32 {
  padding-left: 32px !important;
}

.mb-32 {
  margin-bottom: 32px !important;
}

.mt-16 {
  margin-top: 16px !important;
}

.mr-16 {
  margin-right: 16px !important;
}

.pr-30 {
  margin-right: 30px !important;
}

.ml-30 {
  margin-left: 30px !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pl-20 {
  padding-left: 20px !important;
}

.primary-color {
  color: #0277bd;
}

.theme--light.v-text-field--box .v-input__slot:hover {
  background: white !important;
}

.theme--light.v-textarea .v-input__slot:hover {
  background: white !important;
}

.router-link-active {
  color: rgba(0, 0, 0, 0);
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.size-32 {
  width: 32px !important;
  height: 32px !important;
}
.m-0 {
  margin: 0px !important;
}

.application {
  font-family: 'Source Sans Pro', sans-serif !important;
  background-color: white !important;
}

.headline {
  font-family: 'Raleway', sans-serif !important;
}
.input-grey {
  background-color: #f5f5f5 !important;
}

.page-title {
  font-size: 18px;
  color: #004c8c;
  font-weight: 700;
  margin-bottom: 30px;
  text-transform: uppercase;
}
.p-0 {
  padding: 0 !important;
}

.dialog-title {
  font-family: Raleway, sans-serif;
  font-size: 20px;
  color: #0277bd;
  font-weight: 700;
  text-transform: uppercase;
}

.snackbar-title {
  font-size: 20px;
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
}

.small-title {
  font-size: 14px;
  color: #333333;
  font-weight: 700;
  margin-bottom: 15px;
  display: block;
}

.selection {
  font-family: Raleway, sans-serif;
  font-size: 16px;
  color: #0277bd;
  font-weight: 700;
  text-transform: uppercase;
}

.dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  margin: 0 10px 2px 0;
}

.custom-error-message {
  margin: 8px 0px;
  padding: 0 12px;
}

.flex-shrink {
  flex: 0 1 auto !important;
}

.flex-grow {
  flex: 1 1 auto !important;
}

/* BUILDER STYLES */

.builder-avatar {
  background-size: cover;
}

.builder-flag {
  background-size: contain;
}

.builder-image {
  background-size: cover;
  padding: 0px !important;
}

.builder-qr-code {
  background-size: contain;
  padding: 0px !important;
}

.builder-barcode {
  background-size: contain;
  padding: 0px !important;
}

.builder-oval {
  border-radius: 100px;
}

.full {
  width: 100%;
  height: 100%;
}

.builder-size {
  height: 148.43mm;
  width: 105mm;
}

.theme--light.v-text-field:not(.v-input--has-state) .v-input__slot::before {
  border-color: #979797;
}

.theme--light.v-text-field.v-input--is-dirty:not(.v-input--has-state) .v-input__slot::before {
  border-color: #333;
}

.theme--light.v-text-field:not(.v-input--has-state) .v-input__slot:hover::before {
  border-color: #979797 !important;
}

.theme--light.v-text-field.v-input--is-dirty:not(.v-input--has-state) .v-input__slot:hover::before {
  border-color: #333 !important;
}

.theme--dark.v-text-field:not(.v-input--has-state) .v-input__slot::before {
  border-color: #fff;
}

.v-text-field .v-input__slot::before {
  border-width: 1px 0 0 !important;
}
.v-dialog__activator .v-text-field .v-input__slot::before {
  bottom: 0px !important;
}

.transparent-list {
  background: transparent !important;
}

.screen-title {
  padding-left: 12px;
  margin-bottom: 16px;
  color: #ff4c00;
  font-family: Raleway, sans-serif;
  font-size: 24px;
  font-weight: bold;
}
@media (min-width: 800px) {
  .hide {
    display: none;
  }
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #dedede !important;
}
@media (max-width: 800px) {
  .screen-title:not(.component) span {
    display: none;
  }
  .screen-title:not(.component) {
    margin-top: 16px;
  }
  .mobile-button {
    position: sticky;
    top: calc(100vh - 74px);
    z-index: 10;
    display: flex;
    justify-content: center;
    margin: 0 16px !important;
    height: 0;
  }
  .mobile-buttons {
    position: sticky;
    top: calc(100vh - 100px) !important;
    z-index: 7;
    display: flex;
    justify-content: start;
    height: 0;
    margin: 0px 16px !important;
  }
  .mobile-button * {
    width: 100%;
  }
  .mobile-button span {
    font-size: 18px;
    letter-spacing: -0.015em;
    text-transform: uppercase;
    line-height: 120%;
  }
  .mobile-button button {
    padding: 12px 0;
    width: 100% !important;
    box-shadow: 0px 4px 16px rgba(51, 51, 51, 0.16) !important;
  }
  .desktop-button {
    display: none;
  }
  .mobile-button-container {
    min-height: 90vh;
    margin-bottom: 50px;
  }
}
.screen-description {
  padding-left: 12px;
  margin-bottom: 32px;
  font-size: 16px;
  color: #979797;
}
.theme--light.v-text-field--box .v-input__slot {
  background: white !important;
  border: 1px solid #d9d9d9;
}
.theme--light.v-textarea .v-input__slot {
  background: white !important;
}

.v-menu__content {
  box-shadow: 0 1px 18px 0 rgba(151, 151, 151, 0.25) !important;
  border-radius: 8px !important;
}

.v-list__tile--link:hover {
  background: rgba(2, 119, 189, 0.2);
}

.label {
  line-height: 20px;
  font-size: 16px;
  color: #979797;
}

.v-text-field__details {
  margin-bottom: 0 !important;
}

.action-text {
  font-family: Raleway, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  color: #0277bd;
}
.action-description {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #979797;
}

.clickable {
  cursor: pointer;
}
.v-dialog {
  border-radius: 8px !important;
}
.scrollable {
  overflow: scroll !important;
}
.anchor-button {
  font-size: 16px !important;
  height: 36px !important;
  font-family: Raleway !important;
  font-weight: bold !important;
  line-height: 1.5 !important;
}

/* // ADD CLASS FULL */
</style>
